import type { AnyRouter } from "@tanstack/react-router"
import { z } from "zod"

const deployedVersionSchema = z.object({ version: z.string() })

async function fetchDeployedVersion(): Promise<string | null> {
  const response = await fetch("/version.json", { cache: "no-store" })
  if (!response.ok) return null
  const parsed = deployedVersionSchema.safeParse(await response.json())
  return parsed.success ? parsed.data.version : null
}

export function installVersionCheck(router: AnyRouter): void {
  const current = document.querySelector<HTMLMetaElement>(
    'meta[name="app-version"]',
  )?.content
  if (!current) return

  let stale = false

  const check = async (): Promise<void> => {
    if (stale) return
    const deployed = await fetchDeployedVersion().catch(() => null)
    stale = deployed !== null && deployed !== current
  }

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void check()
  })
  router.subscribe("onBeforeNavigate", ({ toLocation, pathChanged }) => {
    if (!pathChanged) return
    if (stale) window.location.assign(toLocation.href)
    else void check()
  })
}
